const creditsContent = <>
        <div id="poster"></div>

<p>It was summertime in the year 2020. We had been living isolated in the dead heat of the covid-19 pandemic and I was beginning to lose faith in the prospects of filmmaking in the new covid-world. One day my friend Shae Belenski sent me a draft of his writing in a document titled: “drunk.” It was essentially a series of monologues, which Shae had written as “interviews” (read these by clicking on the “Trivial Conspiracies” button.) He was interested in filming some of these monologues, and so we did!
            </p>
            <p>For me, making these films was an escape from the scary reality of our world. Conspiracy theories revolving around the pandemic and the 2020 presidential election were part of the zeitgeist of these years, and this project brought some healing levity to all that harmful nonsense. 
            </p>
            <p>- Sam</p>
            <ul>
                <li>Cast (in order of appearance):</li>
                <li>Brooke Shilling</li>
                <li>Sam Dellert</li>
                <li>Nina Sharp</li>
                <li>Nazlah Black</li>
                <li>Rohaan Unvala</li>
                <li>Renee Comings</li>
                <li>Ryan Pater</li>
                <li>Xan Pemsler</li>
                <li>Sasha Kostyrko</li>
                <li>Anna Phillips</li>
            </ul>
            <ul>
                <li>Director, Cinematographer, Editor</li>
                <li>Sam Dellert</li>
            </ul>
            <ul>
                <li>Writer</li>
                <li>Shae Belenski</li>
            </ul>
            <ul>
                <li>Colorist</li>
                <li>Jake White</li>
            </ul>
            <ul>
                <li>Sound Editor</li>
                <li>Steve Campagna</li>
            </ul>
            <ul>
                <li>Music from</li>
                <li>Barraco Barner</li>
                <li>Jeff Silverman</li>
            </ul>
            <ul>
                <li>Location Sound Mixer</li>
                <li>Matt Ober</li>
            </ul>
            <ul>
                <li>Boom Operator</li>
                <li>Xan Pemsler</li>
            </ul>
            <ul>
                <li>Production Support/Set Photographer</li>
                <li>Renee Comings</li>
            </ul>
            <ul>
                <li>Web Developer</li>
                <li>Michael Shingo Crawford</li>
            </ul>
            <ul>
                <li>Poster Design by</li>
                <li>Tawan Maneetapho</li>
            </ul>
            <ul>
                <li>Thank you</li>
                <li>Martha (Kensington)</li>
                <li>Liberty Choice</li>
                <li>Pro 8mm</li>
                <li>Dana Mandi</li>
            </ul>
            <ul>
                <li>Thank you</li>
                <li>Dellert Family</li>
                <li>Julianna Casella</li>
                <li>Cassidy Minarik</li>
                <li>Peter Charney</li>
                <li>Amitanshu Das</li>
                <li>Megan Wetham</li>
                <li>Trey Shields</li>
            </ul>
            <ul>
                <li>Proudly filmed in Philadelphia, PA</li>
                <li>© 2023</li>
            </ul></>;

export default creditsContent;